import { useRouter } from 'next/router';

import { useAuth } from '@blockworks/session/context';
import { Button, ContentLayout, FlexBox, Layout, Text } from '@blockworks/ui/components';

import SignInSection from '@/components/auth/sign-in-section';
import { GlobalLayout } from '@/layout/global/global-layout';
import TopBar from '@/layout/global/top-bar/top-bar';
import { LayoutHead } from '@/layout/layout-head';

interface ErrorLayoutProps {
    title: string;
    subtitle: string;
}

const ErrorContent = ({ title, subtitle }: ErrorLayoutProps) => {
    const { status } = useAuth();
    const router = useRouter();
    const handleOnClick = (path: string) => () => {
        router.push(path);
    };

    return (
        <FlexBox m={5} center col gap="md" color="muted" py={6} h={300}>
            <Text size="display-md" weight="bold">
                {title}
            </Text>
            <Text size="xl">{subtitle}</Text>
            {status === 'authenticated' && (
                <FlexBox gap="md">
                    <Button intent="primary" center onClick={handleOnClick('/')}>
                        My Dashboard
                    </Button>
                    <Button center onClick={handleOnClick('/support')}>
                        Get Support
                    </Button>
                </FlexBox>
            )}
        </FlexBox>
    );
};

export const ErrorLayout = (props: ErrorLayoutProps) => {
    const { status } = useAuth();
    const metaProps = { title: 'Blockworks Research', description: '' };

    if (status === 'authenticated') {
        return (
            <GlobalLayout metaProps={metaProps}>
                <ContentLayout>
                    <ContentLayout.Container custom>
                        <ErrorContent {...props} />
                    </ContentLayout.Container>
                </ContentLayout>
            </GlobalLayout>
        );
    }

    return (
        <Layout grid>
            <LayoutHead metaProps={metaProps} />
            <Layout.Brand />
            <Layout.Topbar>
                <TopBar />
            </Layout.Topbar>
            <Layout.ContentWithoutSidebar>
                <ContentLayout>
                    <ContentLayout.Container custom>
                        <ErrorContent {...props} />
                        <SignInSection />
                    </ContentLayout.Container>
                </ContentLayout>
            </Layout.ContentWithoutSidebar>
        </Layout>
    );
};
